import React, { useState } from 'react';
import {
	makeStyles,
	MenuItem,
	FormControlLabel,
	useMediaQuery,
	Select,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && 200,
		width: ({ isMobile, width }) => (isMobile ? 200 : width),
		margin: 0,
	},
	root: {
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		padding: '5.5px 14px',
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ disabled, touched, hover }) =>
			(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
}));

const SimpleChipDropdown = ({
	label,
	name,
	onChange,
	value,
	options = [],
	width = '100%',
	labelPos = 'top',
	disabled,
	style = {},
	containerClass = '',
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, width, disabled, touched, hover });

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<Select
					fullWidth
					displayEmpty
					style={style}
					value={value}
					onChange={onChange}
					classes={{ root: classes.root }}
					variant="outlined"
					size="small"
					name={name}
					disabled={disabled}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					renderValue={(selected) => (
						<span
							className={`label label-lg label-light-${
								options.find((op) => op.value === selected)?.color
							} label-inline border border-${
								options.find((op) => op.value === selected)?.color
							}`}
						>
							{options.find((op) => op.value === selected)?.text ||
								'Seleccione una opción'}
						</span>
					)}
				>
					<MenuItem value="">Seleccione una opción</MenuItem>
					{options.map(
						(option) =>
							option && (
								<MenuItem
									key={option.value.id ? option.value.id : option.value}
									value={option.value}
								>
									<div
										className={`label label-lg label-light-${option.color} label-inline`}
									>
										{option.text}
									</div>
								</MenuItem>
							)
					)}
				</Select>
			}
		/>
	);
};

export default SimpleChipDropdown;
